import React from "react";
import "./AboutRungdo.css";
import imgAbout from "../assets/about-1.png";
import imgMission from "../assets/about-2.png";
import imgServe from "../assets/about-3.png";
import imgChoose from "../assets/about-4.png";

export default function AboutRungdo() {
  return (
    <div className="about-rungdo">
      <div className="rungdo-row">
        <div className="rungdo-text">
          <h2>About Rungdo</h2>
          <h4>Your Trusted Online Paint Store in Pakistan</h4>
          <p>
            Rungdo is more than a paint supplier—it's a movement to bring color,
            creativity, and convenience to every corner of Pakistan. As a leading
            online paint store, we offer premium wall paints, tools, and expert
            guidance to help homeowners, contractors, and designers transform their
            spaces with confidence.
          </p>
          <p>
            Whether you're tackling a full home renovation or refreshing a single
            wall, Rungdo makes the process simple, affordable, and expressive.
          </p>
        </div>

        <div className="rungdo-image">
          <img src={imgAbout} alt="About Rungdo" />
        </div>
      </div>
      <div className="rungdo-row reverse">
        <div className="rungdo-image">
          <img src={imgMission} alt="Our Mission" />
        </div>

        <div className="rungdo-text">
          <h2>Our Mission</h2>
          <p>We're here to revolutionize how Pakistan shops for paint. Our mission is to:</p>

          <ul>
            <li>Deliver high-quality, long-lasting paint products</li>
            <li>Simplify color selection and quantity calculation with smart tools</li>
            <li>Support local craftsmanship and DIY culture</li>
            <li>Build trust through fast delivery and transparent pricing</li>
          </ul>
        </div>
      </div>
      <div className="rungdo-row">
        <div className="rungdo-text">
          <h2>Who We Serve</h2>
          <h4>From Karachi to Lahore, Islamabad to Quetta—our clients include:</h4>
          <ul>
            <li>Homeowners seeking durable paints & easy ordering</li>
            <li>Interior designers crafting bold spaces</li>
            <li>Contractors needing reliable bulk supply</li>
            <li>Community leaders beautifying public spaces</li>
          </ul>
          <p>We're proud to serve a growing network of dreamers and doers across Pakistan.</p>
        </div>
        <div className="rungdo-image">
          <img src={imgServe} alt="Who We Serve" />
        </div>
      </div>
      <div className="rungdo-row reverse">
        <div className="rungdo-image">
          <img src={imgChoose} alt="Why Choose Rungdo?" />
        </div>
        <div className="rungdo-text">
          <h2>Why Choose Rungdo?</h2>
          <h4>From Karachi to Lahore, Islamabad to Quetta—our clients include:</h4>
          <ul>
            <li>Wide range of interior & exterior paints</li>
            <li>Easy online ordering with doorstep delivery</li>
            <li>Expert advice on color selection and surface prep</li>
            <li>Trusted by thousands across Pakistan</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
